"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionSheet = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ActionSheetItem_1 = require("./ActionSheetItem");
var __1 = require("..");
var ActionSheet = function (_a) {
    var actions = _a.actions, children = _a.children, _b = _a.stopPropagationOnOpen, stopPropagationOnOpen = _b === void 0 ? false : _b, _c = _a.color, color = _c === void 0 ? 'inherit' : _c, rest = __rest(_a, ["actions", "children", "stopPropagationOnOpen", "color"]);
    var _d = react_1.useState(), anchorEl = _d[0], setAnchorEl = _d[1];
    var close = function () { return setAnchorEl(undefined); };
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(__1.IconButton, __assign({ color: color, onClick: function (event) {
                    if (stopPropagationOnOpen)
                        event.stopPropagation();
                    setAnchorEl(event.target);
                } }, { children: jsx_runtime_1.jsx(__1.Icon.MoreVert, {}, void 0) }), void 0),
            jsx_runtime_1.jsxs(core_1.Menu, __assign({}, rest, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: close }, { children: [actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) {
                        var theAction;
                        if (isShortAction(action)) {
                            var label_1 = action[0], onClick_1 = action[1], icon_1 = action[2];
                            var IconType = icon_1;
                            var IconComponent = void 0;
                            if (IconType !== undefined) {
                                IconComponent = jsx_runtime_1.jsx(IconType, {}, void 0);
                            }
                            theAction = {
                                label: label_1,
                                onClick: onClick_1,
                                icon: IconComponent,
                            };
                        }
                        else {
                            theAction = action;
                        }
                        var label = theAction.label, icon = theAction.icon, onClick = theAction.onClick, confirm = theAction.confirm, rest = __rest(theAction, ["label", "icon", "onClick", "confirm"]);
                        return (jsx_runtime_1.jsx(ActionSheetItem_1.ActionSheetItem, __assign({ label: label, icon: icon, onClick: onClick, confirm: confirm, close: close }, rest), index + "+" + label));
                    }), children] }), void 0)] }, void 0));
};
exports.ActionSheet = ActionSheet;
function isShortAction(action) {
    return action.label === undefined;
}
//# sourceMappingURL=ActionSheet.js.map